<script setup>
    import { computed, onMounted, ref } from 'vue';
  
    import Sidebar from '@/components/siderbar/SidebarComponent';
    import { sidebarWidth } from '@/components/siderbar/state';
    import { useRoute } from 'vue-router';
    import { imageUrl, fileUrl, uploadUrl } from '@/composables/http';
    import useProject from '@/composables/useProject';

    const { loading, data, read, readList, create, update, clientList, projectList, getProjectList, getClientList } = useProject();

    const route = useRoute();

    import CustomPopup from '../components/modals/CustomPopup.vue';
 
 


    const showDropdown = ref(null);
    const downDownList = ref([]);

    //setup popup varibles.
    // Reactive properties
    const showPopup = ref(false); // Controls popup visibility
    const popupIcon = ref(''); // Icon for the popup
    const popupIconSrc = ref(null); // Custom icon source (optional)
    const iconColor = ref(''); // Icon color
    const popupTitle = ref(''); // Popup title
    const content = ref(''); // Popup content
    const cancelText = ref('');
    const confirmText = ref(''); // Confirm button text
    const confirmButtonType = ref(''); // Button type for confirmation

    const autoClose = ref(false);

    const currentConfirmAction = ref(); 

    function filterNumbers(event) {
                var phoneNumber = event.target.value.replace(/\D/g, "");     
                //console.log("phoneNumber", phoneNumber);         
                event.target.value = phoneNumber;
    }

    function showCustomPopup(title, message, _cancelText, _confirmText, _confirmButtonType, confirmFunction = null, _autoClose = false) {

        showPopup.value = true;
        popupTitle.value = title;
        content.value = message;

        cancelText.value = _cancelText;

        confirmText.value = _confirmText;

        confirmButtonType.value = _confirmButtonType;

        if (_confirmButtonType == 'error') {
            popupIconSrc.value = require('@/assets/images/icons/ErrorIcon.png');
        } else {
            //popupIconSrc.value = require('@/assets/images/icons/InfoIcon.png');
        }

        autoClose.value = _autoClose;


        if (confirmFunction) {
            currentConfirmAction.value = confirmFunction;
        }
    }
    function closePopup() {
        showPopup.value = false;

        // Reset values to defaults
        popupTitle.value = '';
        content.value = '';
        confirmText.value = '';
        confirmButtonType.value = '';

        popupIconSrc.value = '';

        currentConfirmAction.value = null;
    }

    function addNameField() {
        data.value.Clients[0].Name.push({ FirstName: '', LastName: '' });
    }

    function removeNameField(index) {
        data.value.Clients[0].Name.splice(index, 1);
    }

    function goBack() {
        window.$router.back();
        //readList();//refresh
    }
    const onSaveCallback = (res) => {
        if (res?.Type == 200) {
            //console.log("OK");
            if (data.value.Id == '00000000-0000-0000-0000-000000000000') {
                showCustomPopup("Client/Project Details Successfully Added!", "", null, "OK", "success", goBack, true);
            } else {
                showCustomPopup("Client/Project Details Successfully Saved!", "", null, "OK", "success", goBack, true);
            }
           
        } else {
            //error res?.Content
            showCustomPopup(res?.content, res?.content, null, "OK", "error");
            //console.log("error");
        }
    }

    function checkFields() {
        //console.log("data.value", data.value);
        if (!data.value.Name) {
            showCustomPopup("Please enter the project name", "", null, "OK", "error");
           
            return;
        }
        if (!data.value.Clients[0].FirstName) {
            showCustomPopup("Please enter the first name of your client", "", null, "OK", "error");
            return;
        }

        if (!data.value.Clients[0].LastName) {
            showCustomPopup("Please enter the last name of your client", "", null, "OK", "error");
            return;
        }
        /** 
        if (!data.value.Clients[0].Address) {
            showCustomPopup("Please enter the address of your client", "", null, "OK", "error");
      
            return;
        }

        if (!data.value.Clients[0].City) {
            showCustomPopup("Please enter the city of your client", "", null, "OK", "error");
             
            return;
        }
        if (!data.value.Clients[0].PostalCode) {
            showCustomPopup("Please enter the postal code of your client", "", null, "OK", "error");
 
            return;
        }
        */
        if (!data.value.Clients[0].Email) {
            showCustomPopup("Please enter email of your client", "", null, "OK", "error");

            return;
        }
        if (!data.value.Clients[0].Phone) {
            showCustomPopup("Please enter phone number of your client", "", null, "OK", "error");

            return;
        }

        if (data.value.Id == '00000000-0000-0000-0000-000000000000') {
            create(onSaveCallback);
        } else {
            update(onSaveCallback);
        }
         
    }

    function addNewClient() {
        var newClient = { BusinessName: null, FirstName: null, LastName: null, SameAddress: true, Address: null, City: null, PostalCode: null, Province: null, Unit: null, Phone: null, Fax: null, Email: null, };
       
        if(data.value.Address != null || data.value.City != null || data.value.PostalCode != null || data.value.Province != null || data.value.Unit != null){
            newClient.Address = data.value.Address;
            newClient.City = data.value.City;
            newClient.PostalCode = data.value.PostalCode;
            newClient.Province = data.value.Province;
            newClient.Unit = data.value.Unit;
        }
        data.value.Clients.push(newClient);
    }
    function removeClient(index) {
        if (data.value.Clients[index])
            data.value.Clients.splice(index, 1);
    }


    function focusDropdown(field, index = -1) {
        //console.log("focusDropdown", field);
        setTimeout(() => {
            showDropdown.value = field + index;
        }, 200); // Add a slight delay to allow option selection
              
    }

    function dismissDropdown() {
        setTimeout(() => {
            showDropdown.value = null;

            //console.log("dismissDropdown", showDropdown.value);
        }, 200); // Add a slight delay to allow option selection
    }              
     
    

    // Handles selection of an option
    function selectOption(option, field, idx) {

        //console.log("options", option, idx);

        if(field.includes("Address")){
            data.value[field] = option[field];
            data.value.City = option.City;
            data.value.PostalCode = option.PostalCode; 
            data.value.Province = option.Province;
            data.value.Name = option.Name;
            data.value.Unit = option.Unit;

            dataChange("Address", 99);

            addressChange("City");
            addressChange("PostalCode");
            addressChange("Province");
            addressChange("Name");
            addressChange("Unit");

        }else{
            data.value.Clients[idx].FirstName = option.FirstName;
            data.value.Clients[idx].LastName = option.LastName;
            data.value.Clients[idx].BusinessName = option.BusinessName;
            data.value.Clients[idx].Phone = option.Phone;
            data.value.Clients[idx].Email = option.Email;
            data.value.Clients[idx].Id = option.Id;
        }
        
        

        dismissDropdown();
       
        //syncOtherFields(option); // Sync other fields if needed
    }

    function sameAddressChange(client) {
        //console.log("sameAddressChange", client);
        if (client.SameAddress) {
            client.Address = data.value.Address;
            client.City = data.value.City;
            client.PostalCode = data.value.PostalCode;
            client.Province = data.value.Province;
            client.Unit = data.value.Unit;
        }else{
            client.Address = null;
            client.City = null;
            client.PostalCode = null;
            client.Province = null;
            client.Unit = null;
        }
    }

    function addressChange(field) {
        data.value.Clients.forEach(client => {
            if (client.SameAddress) {
                switch (field) {
                    case "City":
                        client.City = data.value.City;
                        break;
                    case "PostalCode":
                        client.PostalCode = data.value.PostalCode;
                        break;
                    case "Province":
                        client.Province = data.value.Province;
                        break;
                    case "Unit":
                        client.Unit = data.value.Unit;
                        break;
                }
            }
        });
    }

    function dataChange(field, idx){
        //console.log("dataChange", field);
        showDropdown.value = field.trim() === '' ? null : field + idx;

        //console.log("Dropdown", showDropdown.value);

        downDownList.value = filteredOptions(field, idx);

        //console.log("downDownList", downDownList.value);

        if(idx == 99){
            for(var i = 0; i < data.value.Clients.length; i++){
                var client = data.value.Clients[i];
                if(client.SameAddress){
                    data.value.Clients[i].Address = data.value.Address;
                     
                }
            }
        }
    }


    function isDropdownVisible(field, idx) {
        return showDropdown.value === field + idx;
    }

    function filteredOptions (_field, idx) {
                if (!showDropdown.value) return [];
                var field = showDropdown.value; // 'Name', 'ContactFirstName', or 'LastName'

                //console.log("filteredOptions", field);

                if(field.includes("Address")){
                    field = "Address";
                    const searchValue = data.value[field]?.toLowerCase() || '';
                    //console.log("searchValue", searchValue);
                    //console.log("projectList", projectList.value);
                    return projectList.value
                    .filter((obj) => obj[field]?.toLowerCase().includes(searchValue))
                    .sort((a, b) => {
                        const aVal = a[field]?.toLowerCase() || '';
                        const bVal = b[field]?.toLowerCase() || '';
                        return aVal.localeCompare(bVal);
                    });
                }else{
                    if(field.indexOf("FirstName") > -1)
                        field = "FirstName";
                    if(field.indexOf("LastName") > -1)
                        field = "LastName";
                    if(field.indexOf("BusinessName") > -1)
                        field = "BusinessName";
                    
                    var searchValue = data.value.Clients[idx][field]?.toLowerCase() || '';

                    return clientList.value.filter((obj) => obj[field]?.toLowerCase().includes(searchValue) && obj[field]!='')
                    .sort((a, b) => {
                        const aVal = a[field]?.toLowerCase() || '';
                        const bVal = b[field]?.toLowerCase() || '';
                        return aVal.localeCompare(bVal);
                    });
                }
                
    }

        
            
            
    
    onMounted(() => {
      
        const id = route.params.id;
        read(id || undefined);
        getProjectList();
        getClientList();
       
        //from my contact page.
       
    })
</script>

<template>
    <div class="wrapper" style="background-color: #f1f2f6;">
        <Sidebar />
        <div class="container " :style="{ 'margin-left': sidebarWidth }" v-if="data!=null">

            <div style="height:60px;"></div>
            <h4 style="font-weight:bold;" v-if="data.Id=='00000000-0000-0000-0000-000000000000'">Add New Client/Project</h4>
            <h4 style="font-weight:bold;" v-if="data.Id!='00000000-0000-0000-0000-000000000000'">Edit Client/Project</h4>
            <br />
            <div class="col-12 box " style="margin:0px;">
                
                <form class="row ">
                    <div class="col-12 col-sm-6 ">
                        <label class="form-label">Project Title (i.e: Kitchen Renovation)<span class="mandatory">*</span></label>
                        <input type="text" class="form-control" v-model="data.Name" placeholder="Project Name">
                    </div>
                    <div class="col-8">
                        <label class="form-label">Service Address<span class="mandatory">*</span></label>
                        <div class="autocomplete-container">
                                <input type="text"
                                       v-model="data.Address"
                                       @focus="focusDropdown('Address')"
                                       @blur="dismissDropdown"
                                       @input="dataChange('Address', 99)"
                                       placeholder="Address"
                                       class="form-control" />
                                <ul v-if="isDropdownVisible('Address', 99)" class="dropdown-list">
                                    <li v-for="(option, idx) in downDownList"
                                        :key="idx"
                                        @mousedown.prevent="selectOption(option, 'Address', 99)"
                                        class="dropdown-item">
                                        {{ option.Address }} 
                                    </li>
                                </ul>
                            </div>
                    </div>
                    <div class="col-4">
                        <label class="form-label">Unit</label>
                        <input type="text" class="form-control" v-model="data.Unit" placeholder="Unit" @input="addressChange('Unit')">
                    </div>

                    <div class="col-6 col-sm-4">
                        <label class="form-label">City<span class="mandatory">*</span></label>
                        <input type="text" class="form-control" v-model="data.City" placeholder="City" @input="addressChange('City')">
                    </div>
                    <div class="col-6 col-sm-4 ">
                        <label class="form-label">Province<span class="mandatory">*</span></label>
                        <select class="form-select" v-model="data.Province" @change="addressChange('Province')">
                            <option value="">Please Select</option>
                            <option v-for="obj in $core.data.Provinces" :key="obj" :val="obj">{{obj}}</option>
                        </select>
                    </div>

                    <div class="col-6 col-sm-4">
                        <label class="form-label">Postal Code<span class="mandatory">*</span></label>
                        <input type="text" class="form-control" v-model="data.PostalCode" placeholder="Postal Code" maxlength="7" @input="addressChange('PostalCode')">
                    </div>

                    <div class="col-12" style="margin-top:20px; display: none;">
                        <label class="form-label">Project Information (i.e "Kitchen Demo + Renovation")</label>
                        <textarea type="text" class="form-control" v-model="data.Comments" placeholder="Comments" />
                    </div>

                </form>
            </div>

            <br /><br/>

            <form class=" ">
                <div v-for="(client, index) in data.Clients" :key="index" class="row box m-b-20">
                    <div class="col-md-12  col-12 text-right">
                        <label style="cursor:default; color: var(--bs-teal);" class="material-icons unselectable">person </label>
                        <label class="fs-6" style="position:relative; bottom:5px;">Client/Homeowner {{1+index}}</label>
                    </div>
                    <div class="col-md-12  col-12">
                        <div class="col-md-8 col-12">
                            <label class="form-label">Business Name (If Any)</label>
                            <div class="autocomplete-container">
                                <input type="text"
                                       v-model="client.BusinessName"
                                       @focus="focusDropdown('BusinessName', index)"
                                       @blur="dismissDropdown"
                                       @input="dataChange('BusinessName', index)"
                                       placeholder="Business Name"
                                       class="form-control" />                                
                                        
                                <ul v-if="isDropdownVisible('BusinessName', index) " class="dropdown-list">
                                    <li v-for="(option, idx) in downDownList"
                                        :key="idx"
                                        @mousedown.prevent="selectOption(option, 'BusinessName', index)"
                                        class="dropdown-item">
                                        {{ option.BusinessName }} 
                                    </li>
                                </ul>
                        </div>
                        </div>
                    </div>

                    <div class="col-6">
                        <label class="form-label">First Name<span class="mandatory">*</span></label>
                        <div class="autocomplete-container">
                                <input type="text"
                                       v-model="client.FirstName"
                                       @focus="focusDropdown('FirstName', index)"
                                       @blur="dismissDropdown"
                                       @input="dataChange('FirstName', index)"
                                       placeholder="First Name"
                                       class="form-control" />                                
                                        
                                <ul v-if="isDropdownVisible('FirstName', index) " class="dropdown-list">
                                    <li v-for="(option, idx) in downDownList"
                                        :key="idx"
                                        @mousedown.prevent="selectOption(option, 'FirstName', index)"
                                        class="dropdown-item">
                                        {{ option.FirstName }}  {{ option.LastName }} 
                                    </li>
                                </ul>
                        </div>
                    </div>
                    <div class="col-6">
                        <label class="form-label">Last Name<span class="mandatory">*</span></label>
                        <div class="autocomplete-container">
                                <input type="text"
                                       v-model="client.LastName"
                                       @focus="focusDropdown('LastName', index)"
                                       @blur="dismissDropdown"
                                       @input="dataChange('LastName', index)"
                                       placeholder="Last Name"
                                       class="form-control" />                                
                                        
                                <ul v-if="isDropdownVisible('LastName', index) " class="dropdown-list">
                                    <li v-for="(option, idx) in downDownList"
                                        :key="idx"
                                        @mousedown.prevent="selectOption(option, 'LastName', index)"
                                        class="dropdown-item">
                                        {{ option.FirstName }}  {{ option.LastName }} 
                                    </li>
                                </ul>
                        </div>
                    </div>

                    <div class="col-12" style="display:flex; flex-direction: column; gap: 8px; display:none;">
                        <div v-for="(client, index) in client.Name"
                             :key="index"
                             style="display: flex; gap:4px; align-items: flex-end;">
                            <div style="flex: 1;">
                                <label class="form-label">First Name<span class="mandatory">*</span></label>
                                <input type="text"
                                       class="form-control"
                                       v-model="client.FirstName"
                                       placeholder="First Name">
                            </div>
                            <div style="flex: 1;">
                                <label class="form-label">Last Name<span class="mandatory">*</span></label>
                                <input type="text"
                                       class="form-control"
                                       v-model="client.LastName"
                                       placeholder="Last Name">
                            </div>
                            <div style="display: flex; gap: 4px;">
                                <div class="material-icons unselectable"
                                     style=" cursor: pointer; color: green;"
                                     @click="addNameField">
                                    add_circle
                                </div>
                                <div v-if="client.Name.length > 1"
                                     class="material-icons unselectable"
                                     style=" cursor: pointer; color: red;"
                                     @click="removeNameField(index)">
                                    remove_circle
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-12">
                        <n-checkbox v-model:checked="client.SameAddress" label="Address Same As Above" @change="sameAddressChange(client)" />
                    </div>
                    <div class="col-8">
                        <label class="form-label">Address<span class="mandatory">*</span></label>
                        
                                <input type="text"
                                       v-model="client.Address"                                      
                                       placeholder="Address"
                                       class="form-control" />
                                 
                            
                    </div>
                    <div class="col-4">
                        <label class="form-label">Unit</label>
                        <input type="text" class="form-control" v-model="client.Unit" placeholder="Unit">
                    </div>

                    <div class="col-6 col-sm-4">
                        <label class="form-label">City<span class="mandatory">*</span></label>
                        <input type="text" class="form-control" v-model="client.City" placeholder="City">
                    </div>
                    <div class="col-6 col-sm-4 ">
                        <label class="form-label">Province<span class="mandatory">*</span></label>
                        <select class="form-select" v-model="client.Province">
                            <option value="">Please Select</option>
                            <option v-for="obj in $core.data.Provinces" :key="obj" :val="obj">{{obj}}</option>
                        </select>
                    </div>

                    <div class="col-6 col-sm-4">
                        <label class="form-label">Postal Code<span class="mandatory">*</span></label>
                        <input type="text" class="form-control" v-model="client.PostalCode" placeholder="Postal Code" maxlength="7">
                    </div>

                    <div class="col-6 col-sm-4">
                        <label class="form-label">Phone<span class="mandatory">*</span></label>
                        <input class="form-control" @input="filterNumbers" v-model="client.Phone" placeholder="Phone" type="text" pattern="\d*" maxlength="10">
                    </div>
                    <div class="col-6 col-sm-4">
                        <label class="form-label">Email<span class="mandatory">*</span></label>
                        <input type="email" class="form-control" v-model="client.Email" placeholder="Email">
                    </div>
                    <div class="col-12 col-sm-4" style="min-width: 64px; min-height:44px; text-align: right; text-align: -webkit-right; align-content:end;">
                        <div style="width: 100px; align-content: end;">
                            <div v-show="index == data.Clients.length - 1 " style="color: var(--bs-teal);" class="material-icons unselectable fs-2" @click="addNewClient">person_add</div>
                            <div v-if="data.Clients.length > 1" class="material-icons unselectable" style="color:var(--bs-danger); " @click="removeClient(index);">delete</div>
                        </div>
                    </div>
                </div>
                <div class="col-12">
                    <div style="color:red; font-size:12px; margin-left:10px; font-weight:bold; margin-top:16px; margin-bottom:16px;">* Mandatory information</div>
                </div>

                <div class="col-12" style="text-align:right;">
                    <div class="btn btn-negative" @click="$router.back()" style="margin-right:16px;"> Cancel</div>
                    <div class="btn btn-positive" @click="checkFields" v-if="data.Id=='00000000-0000-0000-0000-000000000000'">Create</div>
                    <div class="btn btn-positive" @click="checkFields" v-if="data.Id!='00000000-0000-0000-0000-000000000000'">Save</div>
                </div>
            </form>


        </div>

        <CustomPopup :visible="showPopup"
                     :icon="popupIcon"
                     :iconSrc="popupIconSrc"
                     :iconColor="iconColor"
                     :title="popupTitle"
                     :content="content"
                     cancelText="null"
                     :confirmText="confirmText"
                     :confirmButtonType="confirmButtonType"
                     :confirmAction="currentConfirmAction"
                     :autoClose="autoClose"
                     @cancel="closePopup" />


    </div>
</template>


<style scoped>


.autocomplete-container {
        position: relative;
        margin-bottom: 16px;
    }

    .form-input {
        width: 100%;
        padding: 8px;
        border: 1px solid #ccc;
        border-radius: 4px;
    }

    .dropdown-list {
        position: absolute;
        top: 100%;
        left: 0;
        right: 0;
        background: white;
        border: 1px solid #ccc;
        border-radius: 4px;
        max-height: 150px;
        overflow-y: auto;
        z-index: 10;
        padding:0px;
    }

    .dropdown-item {
        padding: 8px;
        cursor: pointer;
    }

        .dropdown-item:hover {
            background: #f0f0f0;
        }

    .container2 {
        max-width: 720px;
        background-color: white;
        height: 100vh;
        max-height: 100vh;
        overflow: auto;
        margin: auto 0;
    }

    .title {
        font-weight: 600;
        text-align: center;
        margin: 0px auto;
    }

    .container-fix {
        max-width: 1080px;
        padding-left: 40px !important;
    }

    textarea {
        height: 140px;
    }
</style>

